






























































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import BaseVue from "../../core/BaseVue";
import Porposal from "../../models/porposal/porposal.model";
import breadcrumb from "@/components/shared/breadcrumb/breadcrumb.vue";
import UserService from "@/services/user.service";

@Component
export default class UserBasicInformationComponent extends BaseVue {
  @Prop() readonly profilePicture!: any;
  @Prop() readonly fullName!: string;
  @Prop() readonly email!: string;
  @Prop() readonly identification!: string;
  @Prop() readonly profile!: string;
  @Prop() readonly profilePictureCustomClass!: string;
  @Prop() readonly informationCustomClass!: string;
  @Prop() readonly informationCustomFormat!: string;
  @Prop() readonly informationCustomPadding!: string;
  @Prop() readonly profilePictureCustomPadding!: string;
  @Prop() readonly isSelection!: boolean;
  userOBJ: any = null;
  userService: UserService = new UserService();
  userSelected = {
    profile: "",
    fullName: "",
    identification: "",
    id: undefined,
    sexName: "",
    dob: "",
    academicTitleName: "",
    academicAreaName: "",
    email: ""
  };
  isCardModalActive = false;
  loading: boolean = false;

  modalUser() {
    if (this.userOBJ && !this.userOBJ.user) {
      (this.userSelected.fullName = this.userOBJ.fullName),
      (this.userSelected.profile = this.userOBJ.profileImage),
      (this.userSelected.identification = this.userOBJ.identification);
      (this.userSelected.sexName = this.userOBJ.sexName),
      (this.userSelected.academicTitleName = this.userOBJ.academicTitleName),
      (this.userSelected.academicAreaName = this.userOBJ.academicAreaName),
      (this.userSelected.email = this.userOBJ.email),
      (this.userSelected.id = this.userOBJ.id);
    } else {
      (this.userSelected.fullName = this.userOBJ.user.fullName),
      (this.userSelected.profile = this.userOBJ.user.profileImage),
      (this.userSelected.identification = this.userOBJ.user.identification);
      (this.userSelected.sexName = this.userOBJ.user.sexName),
      (this.userSelected.academicTitleName = this.userOBJ.user.academicTitleName),
      (this.userSelected.academicAreaName = this.userOBJ.user.academicAreaName),
      (this.userSelected.email = this.userOBJ.user.email),
      (this.userSelected.id = this.userOBJ.user.id);
    }
    this.isCardModalActive = true;
  }

  viewCv(id: number) {
    this.$router.push("/curriculum/" + id);
  }
  
  async mounted() {
    this.loading = true;
    this.userOBJ = await this.userService.getUserByEmail(this.email);
    this.loading = false;
  }

}
